import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from './../shared/shared.module';
import { MonitoringMatrixComponent } from './components/monitoring-matrix/monitoring-matrix.component';
import { TaskListComponent } from './components/task-list/task-list.component';
import { TaskComponent } from './components/task/task.component';
import { TaskConstantsService } from './services/task-constants.service';
import { TaskService } from './services/task.service';
import { TaskRoutingModule } from './task-routing.module';

@NgModule({
  imports: [
    CommonModule,
    TaskRoutingModule,
    SharedModule
  ],
  declarations:
    [
      TaskComponent,
      TaskListComponent,
      MonitoringMatrixComponent
    ],
  providers: [
    TaskService,
    TaskConstantsService,

  ]
})
export class TaskModule { }
